module.exports = __webpack_public_path__ + "media/images/logo-white-74d7c5a280b93f166302884cf5b45101.png";